import React from 'react';
import { useState, useEffect } from 'react';
import './Banners.css'

/** Exercise 1 */
function BannerReportAnswer() {

    const [bannerResults, setBannerResults] = useState([]); // Store banner report from backend.

    // Retrieve banner report when upon first component render.
    useEffect(() => {
        
        const fetchBannerResults = async () => {
            try {
                const response = await fetch('/api/banners')

                // Stop processing if API returns unsucessfully.
                if (!response.ok) {
                    throw new Error(`Error:  ${response.status}`)
                }

                const data = await response.json();
                setBannerResults(data);

            } catch (error) {
                console.error('Error fetching Banner results:', error);
            }
        }
        fetchBannerResults();
    }, []);

    // report results should be displayed here.
    return (
    <>
        <em>The results will go here</em>
        <br/>
        <br />

        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Link</th>
                    <th>Total Impressions</th>
                    <th>Total Clicks</th>
                </tr>
            </thead>
            <tbody>
                {bannerResults?.map(result => (     // Display banner results
                    <tr key={result.bannerId}>
                        <td>{result.name}</td>
                        <td>
                            <a href={result.link}>{result.link}</a>
                        </td>
                        <td>{result.totalImpressions}</td>
                        <td>{result.totalClicks}</td>
                    </tr>
                ))}
            </tbody>
        </table>
       <br/>
    </>
    )
}

/** DO NOT MODIFY */
export function Banners() {
    return <div>
        <h1>Exercise 1 - Banner Analytics</h1>

        <p>There are 2 tables in the database "webapp" called: <strong>Banner</strong> and <strong>BannerTracking</strong>.</p>

        <p>Please create a query that returns the following:</p>
        <p>Banner Name and Banner Link fields and the sum of all impressions and the sum of all clicks between 11/18/2021 and 11/24/2021</p>

        <BannerReportAnswer />

        <h2><strong>Banner</strong> table</h2>
        <img src="/images/banner_design.png" alt="Banner Table Design" /><br />

        <h2><strong>BannerTracking</strong> table</h2>
        <img src="/images/bannertracking_design.png" alt="BannerTracking Table Design" /><br />

        <h2><strong>Banner</strong> table data</h2>
        <img src="/images/banner_data.png" alt="Banner Table Data" /><br />

        <h2><strong>BannerTracking</strong> table data</h2>
        <img src="/images/bannertracking_data.png" alt="BannerTracking Table Data" /><br />
    </div>
}
